import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

import { Layout, Menu, Switch } from "antd";
import Logo from "../../images/Logo_1.png";
import "./menu_logo.css";
import Coupons from "../coupons/coupons";
import CrcPages from "../crc_pages/crcPages";
import MainCrc from "../crc_pages/MainCrc";
import axios, { switchEnv, getCurrentEnv } from "../../axiosConfig";
import Objects from "../cloud_delivery/objects";
import Leaderboards from "../leaderboards/leaderboards";
import CreateVendor from "../create_vendor/CreateVendor";
import VendorList from "../create_vendor/VendorList";
import UserCreation from "../user_creation/UserCreation";
const { Content, /*Footer*/ Sider } = Layout;
export const ParentCrcPages = React.createContext();

export default function MenuCms() {
  const [crcPages, setCrcPages] = useState([]);
  const [page, setPage] = useState({});
  const [menus, hideMenus] = useState(true);
  const [crcInfo, setCrcInfo] = useState({});
  const [crcParent, setCrcParent] = useState({});
  const [apiEnv, setApiEnv] = useState(getCurrentEnv());

  useEffect(() => {
    axios.get("/curriculum-tree/list-crc-pages/").then((res) => {
      setCrcPages(res.data.courses);
      hideMenus(false);
    });
  }, []);

  function UpdateCrcPages(pagesArr, page) {
    setCrcPages(() => pagesArr);
    setPage(page);
  }

  function ShowInspectionMenus(currCrc) {
    setCrcInfo(currCrc);
  }
  function SetParentCrc(crc_parent) {
    setCrcParent(crc_parent);
  }

  return (
    <ParentCrcPages.Provider
      value={{
        crcPages,
        UpdateCrcPages,
        ShowInspectionMenus,
        crcInfo,
        SetParentCrc,
        crcParent,
      }}
    >
      <div>
        <Router>
          <Routes>
            <Route path="/create-vendor" element={<CreateVendor />} />
            <Route path="/vendors-list" element={<VendorList />} />
            <Route path="/*" element={
              <Layout style={{ width: "100vw", height: "100vh" }}>
                <Sider style={{ height: "110vh" }}>
                  <img src={Logo} alt="" className="menu-logo" />
                  <Menu theme="dark" mode="inline" defaultSelectedKeys={["0"]}>
                    <Menu.Item key="0" disabled={menus}>
                      Curriculum's
                      <Link to="/" />
                    </Menu.Item>
                    <Menu.Item key="1">
                      Cloud delivery<Link to="/cloud"></Link>
                    </Menu.Item>
                    <Menu.Item key="2">Status</Menu.Item>
                    <Menu.Item key="3">
                      Coupons<Link to="/coupons"></Link>
                    </Menu.Item>
                    <Menu.Item key="4">
                      Leaderboards<Link to="/leaderboards"></Link>
                    </Menu.Item>
                    <Menu.Item key="5">
                      User Creation<Link to="/user-creation"></Link>
                    </Menu.Item>
                  </Menu>
                  <div style={{ padding: "16px", textAlign: "center" }}>
                    <Switch
                      className="env-switch"
                      checked={apiEnv === "dev"}
                      checkedChildren="DEV"
                      unCheckedChildren="PROD"
                      style={{
                        backgroundColor: apiEnv === "dev" ? "#2f54eb" : "#cf1322",
                      }}
                      onChange={(checked) => {
                        const env = checked ? "dev" : "prod";
                        switchEnv(env);
                        setApiEnv(env);
                        window.location.reload();
                      }}
                    />
                  </div>
                </Sider>
                <Layout style={{ backgroundColor: "white" }}>
                  <Content style={{ margin: "36px 16px 0" }}>
                    <Routes>
                      <Route path="/" element={<CrcPages page={page} />} />
                      {crcPages.map((p) => (
                        <Route
                          key={p.id}
                          path={`/${p.crc_id}/*`}
                          element={<MainCrc />}
                        />
                      ))}
                      <Route path="/cloud" element={<Objects />}></Route>
                      <Route path="/coupons" element={<Coupons />}></Route>
                      <Route path="/leaderboards" element={<Leaderboards />}></Route>
                      <Route path="/user-creation" element={<UserCreation />}></Route>
                    </Routes>
                  </Content>
                </Layout>
              </Layout>
            } />
          </Routes>
        </Router>
      </div>
    </ParentCrcPages.Provider>
  );
}
